export default __webpack_public_path__ + "static/media/sortedLogoHeader.eff61d1d.png";